import React, { useMemo } from 'react';
import { venteBriefFromApi } from '../../utils/kkpVenteBriefUtils';
import { briefPiecesJointesFromVente } from '../../utils/kkpBriefFichierUtils';
import KkpBriefAttachmentsViewer from './KkpBriefAttachmentsViewer';
import { AppAlert, AppButton, AppModal } from '../ui';
import '../../styles/kkp-pub-graphiste.scss';

const KkpVenteBriefModal = ({
  show,
  onClose,
  vente = null,
  onError,
}) => {
  const briefText = useMemo(
    () => (vente ? venteBriefFromApi(vente.brief_encart) : ''),
    [vente],
  );
  const piecesJointes = useMemo(
    () => (vente ? briefPiecesJointesFromVente(vente) : []),
    [vente],
  );

  if (!show || !vente) return null;

  const hasBrief = briefText.trim() !== '';
  const hasAttachments = piecesJointes.length > 0;

  return (
    <AppModal
      show
      size="lg"
      centered
      onClose={onClose}
      title={(
        <>
          Brief créatif — {vente.client_label}
          <span className="badge kkp-pub-graphiste-canal-badge ms-2">{vente.canal_label}</span>
        </>
      )}
      footer={(
        <AppButton size="sm" variant="outline-secondary" onClick={onClose}>Fermer</AppButton>
      )}
    >
            <dl className="row g-2 mb-3 kkp-pub-graphiste-brief-meta">
              <div className="col-sm-6">
                <dt className="text-secondary-light">Format</dt>
                <dd className="mb-0">{vente.format || '—'}</dd>
              </div>
              <div className="col-sm-6">
                <dt className="text-secondary-light">Contenu</dt>
                <dd className="mb-0">{vente.contenu || '—'}</dd>
              </div>
              <div className="col-sm-6">
                <dt className="text-secondary-light">Période</dt>
                <dd className="mb-0">{vente.periode_label || '—'}</dd>
              </div>
              <div className="col-sm-6">
                <dt className="text-secondary-light">Commercial</dt>
                <dd className="mb-0">{vente.commercial_nom || '—'}</dd>
              </div>
            </dl>

            {!hasBrief && !hasAttachments ? (
              <AppAlert variant="warning" className="mb-0">
                Le brief créatif n&apos;a pas encore été renseigné pour cette publicité.
                Le commercial doit le compléter depuis le planning.
              </AppAlert>
            ) : !hasBrief ? null : (
              <div className="kkp-pub-graphiste-brief-content">
                {briefText}
              </div>
            )}

            {hasAttachments && (
              <KkpBriefAttachmentsViewer
                venteId={vente.id}
                piecesJointes={piecesJointes}
                onError={onError}
              />
            )}
    </AppModal>
  );
};

export default KkpVenteBriefModal;
